

const palette = {
  torchRed: {
    100: '#FE1251',
    120: '#BA264D',
    75: '#FE4D7C',
    50: '#FE88A8',
    25: '#FFC4D3',
    15: '#FFDBE5',
    7: '#FFEEF3',
    4: '#FFF6F8' },

  electricBlue: {
    100: '#022AFF',
    120: '#182D99',
    75: '#415FFF',
    50: '#8094FF',
    25: '#C0CAFF',
    15: '#D9DFFF',
    7: '#EDF0FF',
    4: '#F5F6FF' },

  business: {
    100: '#022AFF',
    120: '#182D99',
    75: '#415FFF',
    50: '#848BA4',
    25: '#C1C5D1',
    15: '#DADCE4',
    7: '#EEEFF2',
    4: '#F5F6FF' },

  yolk: {
    100: '#FFC700',
    120: '#EDA210',
    75: '#FFD540',
    50: '#FFE380',
    25: '#FFF1BF',
    15: '#FFF7D9',
    7: '#FFFBED',
    4: '#FFFDF5' },

  broccoli: {
    100: '#53B023',
    120: '#47961E',
    75: '#7EC45A',
    50: '#A9D791',
    25: '#D4EBC8',
    15: '#E5F3DE',
    7: '#F3F9F0',
    4: '#F8FDF5' },

  eggplant: {
    100: '#62319E',
    120: '#492577',
    75: '#8964B6',
    50: '#B098CE',
    25: '#D8CBE7',
    15: '#E7E0F0',
    7: '#F4F1F8',
    4: '#F9F6FC' },

  tomato: {
    100: '#EF432D',
    120: '#B33222',
    75: '#F37261',
    50: '#F7A196',
    25: '#FBD0CA',
    15: '#FDE3E0',
    7: '#FEF2F0',
    4: '#FEF7F7' },

  grey: {
    100: '#333333',
    120: '#262626',
    75: '#666666',
    50: '#999999',
    25: '#CCCCCC',
    15: '#E0E0E0',
    7: '#F1F1F1',
    4: '#F7F7F7' } };



export default palette;